<template>
<div>
    <!-- fixed-bottom-nav -->
    <!-- <div class="bottombar-large" style="margin-top:5em; margin-left: -2em; width: 400px;">
        <div style="padding-left:1em;">
            <a href="/"><i class="fa fa-list"></i><br><span>Timeline</span></a>
            <a href="/shop"><i class="fa fa-home"></i><br><span>Shop</span></a>
            <a href="/account"><i class="fa fa-user"></i><br><span>Account</span></a>
            <a href="/notifications"><i class="fa fa-bell"></i><br><span>Notifications</span></a>
        </div>
    </div> -->

    <!---mobile-->
    <div class="bottombar" style="margin-top:15em;">
        <div class="row">
            <a href="/timeline" class="col-xs-3"><i class="fa fa-home"></i><br><span>Shops</span></a>
            <a href="/account" class="col-xs-3"><i class="fa fa-search"></i><br><span>Search</span></a>
            <a href="/notifications" class="col-xs-3"><i class="fa fa-bell"></i><br><span>Notifications</span></a>
            <a href="/cart" class="col-xs-3"><i class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
        </div>
    </div>
    <!--./mobile-->
   
    <!--./ fixed-bottom-nav -->
 </div>
</template>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'MenuBottom',
    data () {
      return {
       
      }
  },
}
</script>


// WEBPACK FOOTER //
// menubottom.vue?09e31fd6